import { type Control, type FieldValues, type Path, useController } from "react-hook-form";
import { MessageComposer, type MessageComposerProps } from "./message-composer";

type MessageComposerFieldProps<T extends FieldValues> = Omit<MessageComposerProps, "value" | "onChange" | "onBlur"> & {
  control: Control<T>;
  name: Path<T>;
};

export function MessageComposerField<T extends FieldValues>({ control, name, ...props }: MessageComposerFieldProps<T>) {
  const { field, fieldState } = useController({ control, name });
  const errorMessage = fieldState.error?.message;

  return (
    <MessageComposer
      {...props}
      value={field.value ?? ""}
      onChange={field.onChange}
      onBlur={field.onBlur}
      invalid={props.invalid ?? !!fieldState.error}
    >
      {errorMessage && <p className="-mt-1.5 text-sm text-error-primary">{errorMessage}</p>}
      {props.children}
    </MessageComposer>
  );
}
